import { ReactNode } from "react";
import { HStack } from "goi_common";
import { DefaultPageContainer } from "./container";

interface Props {
  children: ReactNode;
  title: string;
  chip?: ReactNode;
}

const DefaultPageLayout = ({ children, title, chip }: Props) => {
  return (
    <DefaultPageContainer>
      <HStack gap="8px" alignItems="center">
        <h1 className="subtitle_21_b">{title}</h1>
        {chip && chip}
      </HStack>
      {children}
    </DefaultPageContainer>
  );
};

export default DefaultPageLayout;
